import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LegalAgreementsContact from "@/components/legal/LegalAgreementsContact";

const TextMessagePolicy = () => {
  const { t } = useTranslation();
  const [, setActiveSection] = useState<string | null>(null);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
    }
  };

  const tableOfContents = Array.from({ length: 11 }, (_, i) => ({
    id: `section-${i + 1}`,
    title: t(`textMessagePolicy_toc${i + 1}`),
  }));

  const renderSectionBody = (n: number, body: string) => {
    if ((n === 1 || n === 11) && body.includes("www.jandipr.com")) {
      return (
        <p className="text-gray-700 leading-relaxed">
          {body.split("www.jandipr.com").map((part, i, arr) =>
            i < arr.length - 1 ? (
              <React.Fragment key={i}>
                {part}
                <a
                  href="https://www.jandipr.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-darkBlue underline"
                >
                  www.jandipr.com
                </a>
              </React.Fragment>
            ) : (
              part
            )
          )}
        </p>
      );
    }
    return body.split(/\n\n/).map((para, i) => (
      <p key={i} className="text-gray-700 leading-relaxed">
        {para}
      </p>
    ));
  };

  return (
    <div className="min-h-screen bg-home">
      <header className="bg-darkBlue text-white">
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-12 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
            {t("textMessagePolicy_pageTitle")}
          </h1>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8 p-4 bg-lightBlue border-l-4 border-darkBlue rounded-r-lg">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">{t("textMessagePolicy_lastUpdatedLabel")}</span>{" "}
            {t("textMessagePolicy_lastUpdatedText")}
          </p>
        </div>

        <div className="mb-12 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 bg-lightBlue border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              {t("textMessagePolicy_tocTitle")}
            </h2>
          </div>
          <div className="px-6 py-4 grid grid-cols-1 md:grid-cols-2 gap-2">
            {tableOfContents.map((item, index) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-left p-2 text-darkBlue hover:text-indigo-800 hover:bg-lightBlue rounded transition-colors duration-200"
              >
                <span className="">{index + 1}.</span> {item.title}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-12">
          {Array.from({ length: 11 }, (_, i) => i + 1).map((n) => (
            <section key={n} id={`section-${n}`} className="scroll-mt-8">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 bg-lightBlue border-b border-gray-200 flex items-center gap-3">
                  <span className="bg-darkBlue text-white px-3 py-1 rounded-full text-sm font-bold">
                    {n === 1 ? "Intro" : n}
                  </span>
                  <h2 className="text-2xl font-bold text-gray-900">
                    {t(`textMessagePolicy_s${n}Title`)}
                  </h2>
                </div>
                <div className="px-6 py-6 text-gray-700 leading-relaxed space-y-4">
                  {renderSectionBody(n, t(`textMessagePolicy_s${n}Body`))}
                </div>
              </div>
            </section>
          ))}

          <LegalAgreementsContact />
        </div>
      </div>
    </div>
  );
};

export default TextMessagePolicy;
